import { Languages } from 'lucide-react'
import { useI18n } from '../i18n'

export function LanguageSelect() {
  const { locale, setLocale, t } = useI18n()
  return <label className="flex items-center gap-2 text-sm text-muted-foreground">
    <Languages size={16} />
    <span className="sr-only">{t('common.language')}</span>
    <select aria-label={t('common.language')} className="bg-transparent outline-none" value={locale} onChange={(event) => setLocale(event.target.value as 'en' | 'zh')}>
      <option value="en">{t('common.english')}</option>
      <option value="zh">{t('common.chinese')}</option>
    </select>
  </label>
}
